// extracted by mini-css-extract-plugin
module.exports = {"variableAmountInput":"AmountScreen_variableAmountInput__1JB1_"};